import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import GroupTravelTheme from "../components/GroupTravelTheme";
import BannerGroupTravel from "../components/BannerGroupTravel";
import PlanningTrip from "../components/PlanningTrip";
import GroupContact from "../components/GroupContact";
import Clients from "../components/Clients";
import Footer from "../components/Footer";
import HeaderLanding from "../components/HeaderLanding";
import FamilyTravelDetailLanding from "../components/FamilyTravelDetailLanding";
import FamilyTravelCTALanding from "../components/FamilyTravelCTALanding";
import FixFamilyTravelLanding from "../components/FixFamilyTravelLanding";
import TestimonialView from "../components/TestimonialView";
import TestimonialLanding from "../components/TestimonialLanding";

const FamilyTravelLanding: React.FC = () => {
  return (
    <div>
      <HeaderLanding />
      <FamilyTravelDetailLanding />
      <FixFamilyTravelLanding />
     <TestimonialLanding/>
      <FamilyTravelCTALanding />
        <PlanningTrip
        headingplanning="Start Planning Your Family Adventure"
        paragraph="Let us take care of the details while you enjoy quality time with your Family."
      />
      <Clients />
      <Footer />
    </div>
  );
};

export default FamilyTravelLanding;
